<!-- FILE_VERSION: AppVue-v1.0 -->
<template>
  <router-view />
</template>

<script setup>
</script>

<style>
*, *::before, *::after {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

html, body, #app {
  width: 100%;
  height: 100%;
  margin: 0;
  padding: 0;
  overflow: auto;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei', 'Helvetica Neue', Helvetica, Arial, sans-serif;
}

/* 全局页面容器样式 */
.el-container {
  width: 100%;
}

.el-main {
  height: 100%;
  padding: 0;
}

/* 通用页面样式 */
[class$="-page"] {
  min-height: 100%;
  padding: 20px;
  background-color: #f0f4f8;
}

/* 卡片样式 - 科技蓝风格 */
.el-card {
  border-radius: 12px;
  border: none;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
  transition: box-shadow 0.3s;
}

.el-card:hover {
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
}

/* 按钮样式优化 */
.el-button--primary {
  background: linear-gradient(135deg, #1976d2 0%, #0d47a1 100%);
  border: none;
}

.el-button--primary:hover {
  background: linear-gradient(135deg, #1e88e5 0%, #1565c0 100%);
}

/* 表格样式优化 */
.el-table {
  border-radius: 8px;
  overflow: visible;
}

.el-table th.el-table__cell {
  background-color: #f8fafc !important;
  color: #475569;
  font-weight: 600;
}

.el-table--striped .el-table__body tr.el-table__row--striped td.el-table__cell {
  background-color: #f8fafc;
}

/* 分页样式 */
.el-pagination {
  margin-top: 20px;
  justify-content: flex-end;
}

/* 表单样式 */
.el-form-item__label {
  color: #475569;
  font-weight: 500;
}

/* 标签页样式 */
.el-tabs--border-card {
  border-radius: 8px;
  border: none;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
}

/* 下拉菜单样式 */
.el-dropdown-menu {
  border-radius: 8px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
}

/* 消息提示样式 */
.el-message {
  border-radius: 8px;
}

/* 对话框样式 */
.el-dialog {
  border-radius: 12px;
}

/* 选择框样式 */
.el-select .el-input__wrapper {
  border-radius: 8px;
}

/* 输入框样式 */
.el-input__wrapper {
  border-radius: 8px;
}

/* 主题色变量 */
:root {
  --primary-color: #1976d2;
  --primary-dark: #0d47a1;
  --primary-light: #64b5f6;
  --sidebar-bg: #0a1628;
  --header-bg: #ffffff;
  --content-bg: #f0f4f8;
  --card-bg: #ffffff;
  --text-primary: #1e293b;
  --text-secondary: #64748b;
  --border-color: #e2e8f0;
}
/* 移除焦点边框 */ button:focus, .el-button:focus, *:focus { outline: none !important; }
</style>
